import { Translate } from "ra-core";
import type { ReactNode } from "react";

export const FilterCategory = ({
  icon,
  label,
  action,
  children,
}: {
  icon: ReactNode;
  label: string;
  /** Sits at the end of the heading, e.g. a SettingsShortcut. */
  action?: ReactNode;
  children?: ReactNode;
}) => (
  <div className="flex flex-col gap-2">
    <h3 className="flex flex-row items-center gap-2 font-bold text-sm">
      {icon}
      <Translate i18nKey={label} />
      {action && <span className="ml-auto flex items-center">{action}</span>}
    </h3>
    <div className="flex md:flex-col flex-wrap items-start pl-4">
      {children}
    </div>
  </div>
);
